import { Experiment } from '@remote-data/load-experiments/types';

export enum ExperimentsActionsEnum {
  SET_EXPERIMENTS = '@experiments/SET_EXPERIMENTS',
  SET_COOKIE_CREATED = '@experiments/SET_COOKIE_CREATED',
}

export type ExperimentsState = { data: Experiment[]; cookieCreated: false };
